import axios from 'axios';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PriceSidebar from './PriceSidebar';
import Stepper from './Stepper';
import { clearErrors } from '../../actions/orderAction';
import { useSnackbar } from 'notistack';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import MetaData from '../Layouts/MetaData';
import { post } from '../../utils/paytmForm'; 
import { emptyCart } from '../../actions/cartAction'; // Adjust path as necessary
import { useNavigate } from 'react-router-dom'; 

const Payment = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();

    const [payDisable, setPayDisable] = useState(false);
    const { shippingInfo, cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);
    const { error } = useSelector((state) => state.newOrder);
    const [paymentMethod, setPaymentMethod] = useState('paytm'); // Default to Paytm

    // Calculate total price
    const totalPrice = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);

    const submitHandler = async (e) => {
        e.preventDefault();
        setPayDisable(true); 
    
        try {
            const paymentInfo = paymentMethod === 'cod' 
                ? { id: 'COD', status: 'Pending' } 
                : { id: 'PhonePay', status: 'Pending' } 
    
            const orderData = {
                shippingInfo,
                orderItems: cartItems,
                totalPrice,
                paymentInfo, 
                email: user.email,
                phoneNo: shippingInfo.phoneNo,
            };
    
            if (paymentMethod === 'cod') {
                await axios.post('/api/v1/order/new', orderData);
                enqueueSnackbar("Order placed successfully!", { variant: "success" });
                dispatch(emptyCart());
                navigate("/order/success");
            } else {
                  try {
                    const { data } = await axios.post('/api/v1/payment/process', orderData);
                    console.log(data)
                    dispatch(emptyCart());
                    //window.location.href = response.data.url
                  } catch (error) {
                    console.log("error in payment", error)
                  }
            }

             
        } catch (error) {
            //setPayDisable(false); // Re-enable button on error
            enqueueSnackbar(error.response?.data?.message || "Payment initiation failed", { variant: "error" });
        }
    };
    

    useEffect(() => {
        if (error) {
            dispatch(clearErrors());
            enqueueSnackbar(error, { variant: "error" });
        }
    }, [dispatch, error, enqueueSnackbar]);

    return (
        <>
            <MetaData title="Siddhi Creatives: Secure Payment" />

            <main className="w-full mt-20">
                <div className="flex flex-col sm:flex-row gap-3.5 w-full sm:w-11/12 mt-0 sm:mt-4 m-auto sm:mb-7">
                    <div className="flex-1">
                        <Stepper activeStep={3}>
                            <div className="w-full bg-white">
                                <form onSubmit={submitHandler} autoComplete="off" className="flex flex-col justify-start gap-2  mx-8 my-4 overflow-hidden">
                                    <h2>Select Payment Method</h2>
                                    <FormControl component="fieldset">
                                        <RadioGroup
                                            aria-labelledby="payment-radio-group"
                                            defaultValue="paytm" // Default selected payment method
                                            name="payment-radio-button"
                                            onChange={(e) => setPaymentMethod(e.target.value)} // Handle change to update state
                                        >
                                            <FormControlLabel
                                                value="paytm"
                                                control={<Radio />}
                                                label={
                                                    <div className="flex items-center gap-4">
                                                        <span>Phone Pay</span>
                                                    </div>
                                                }
                                            />
                                            <FormControlLabel
                                                value="cod"
                                                control={<Radio />}
                                                label={
                                                    <div className="flex items-center gap-4">
                                                        <span>Cash on Delivery (COD)</span>
                                                    </div>
                                                }
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                    <button 
                                        type="submit" 
                                        disabled={payDisable} 
                                        className={`bg-primary-orange w-full sm:w-1/3 my-2 py-3 text-sm font-medium text-white shadow hover:shadow-lg uppercase transition duration-300 ease-in-out ${payDisable ? 'opacity-50 cursor-not-allowed' : ''}`}
                                    >
                                        Pay Now
                                    </button>
                                   
                                </form>
                            </div>
                        </Stepper>
                    </div>

                    <PriceSidebar cartItems={cartItems} />
                </div>
            </main>
        </>
    );
};

export default Payment;
